<div class="input-text-wrapper" [class.fluid]="fluid()">
  <label *ngIf="label()" [for]="id()" class="input-label">{{ label() }}</label>

  <p-inputgroup *ngIf="icon(); else plainInput" size="small">
    <p-inputgroup-addon *ngIf="iconPosition() === 'left'">
      <i class="{{ icon() }}"></i>
    </p-inputgroup-addon>
    <input
      class="text-xs border-none"
      pInputText
      [id]="id()"
      [ngModel]="value()"
      (ngModelChange)="value.set($event)"
      [type]="type()"
      [placeholder]="placeholder()"
      [disabled]="disabled()"
      [readonly]="readonly()"
      [maxlength]="maxlength() ?? 524288"
      [ngClass]="styleClass()"
      [attr.data-size]="size()"
      (input)="handleInput($event)"
      (blur)="handleBlur($event)"
      (focus)="handleFocus($event)" 
      size="small"/>
    <p-inputgroup-addon *ngIf="iconPosition() === 'right'">
      <i class="{{ icon() }}"></i>
    </p-inputgroup-addon>
  </p-inputgroup>

  <ng-template #plainInput>
    <input
      pInputText
      [id]="id()"
      [ngModel]="value()"
      (ngModelChange)="value.set($event)"
      [type]="type()"
      [placeholder]="placeholder()"
      [disabled]="disabled()"
      [readonly]="readonly()"
      [maxlength]="maxlength() ?? 524288"
      [ngClass]="styleClass()"
      [class.p-inputtext-sm]="size() === 'small'"
      [class.text-xs]="size() === 'small'"
      [attr.data-size]="size()"
      (input)="handleInput($event)"
      (blur)="handleBlur($event)"
      (focus)="handleFocus($event)" />
  </ng-template>
</div>
